module.exports = require('./dist/Sticky');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-stickynode/index.js
 ** module id = 260
 ** module chunks = 44
 **/